module.exports = __webpack_public_path__ + "img/process-icon-active.ac8b29ab.svg";